<h3>Main Timeline</h3>
<i>{{events.length}} entries recorded</i>

<div class='row align-self-center m-3'>
    <mzd-timeline [alternateSide]='true' *ngFor="let event of events">
        <mzd-timeline-content [border]="true" [card]="false">

            <div class=" card-header bg-native">
                <a href="{{imgURL}}" target="_blank" title="View full picture"><img
                        class='card-img-top img-thumbnail logo text-end' src="{{imgURL}}"></a>
                <h6 class="card-title text-light">{{event.name}}</h6>
            </div>
            <div class="card-body" *ngIf='show'>

                <p class="card-text">
                    {{event.description}}
                </p>
                <ul class='list-group small m-3'>
                    <li class="list-group-item card-subtitle bg-info">Relevant Links</li>
                    <a class="list-group-item text-truncate" [hidden]="link === ''"
                        *ngFor="let link of event.relLinks; let i = index" href="{{link}}" title="{{link}} "
                        target="_blank"><i class="bi bi-link-45deg"></i> {{link}}</a>
                </ul>
                <small class="card-text me-2">Tags:</small>
                <span class="btn-group d-flex flex-wrap">

                    <a routerLink="/search-tags/{{tag}}" class='btn btn-sm btn-secondary border border-white rounded'
                        *ngFor="let tag of event.tags">{{tag}}</a>
                </span>
            </div>
            <div class="card-footer bg-native">
                <small class="card-subtitle text-light">{{ monthToString(event.startPeriod.month) }}
                    {{event.startPeriod.day}}<small *ngIf='event.startPeriod.day'>,</small>
                    {{event.startPeriod.year}}
                    <small *ngIf="!(!event.endPeriod.year)">to</small>
                    {{ monthToString(event.endPeriod.month) }}
                    {{event.endPeriod.day}}<small *ngIf='event.endPeriod.day'>,</small>
                    {{event.endPeriod.year}}
                </small>
            </div>

            <mzd-icon>
                <i style="display: flex; height: fit-content;" (click)='toggle()' class="{{icon}}"
                    title='{{status}} the entry'></i>
            </mzd-icon>
        </mzd-timeline-content>

    </mzd-timeline>

</div>